import React, { useState } from 'react';
import GSTCalculator from './components/GSTCalculator';
import IncomeTaxCalculator from './components/IncomeTaxCalculator';
import TDSCalculator from './components/TDSCalculator';
import AdvanceTaxCalculator from './components/AdvanceTaxCalculator';

function App() {
  const [activeTab, setActiveTab] = useState('gst');
  
  const tabs = [
    { id: 'gst', name: 'GST Calculator', icon: '🧾' },
    { id: 'income-tax', name: 'Income Tax', icon: '💰' },
    { id: 'tds', name: 'TDS Calculator', icon: '📊' },
    { id: 'advance-tax', name: 'Advance Tax', icon: '📅' },
  ];

  return (
    <div className="min-h-screen py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <header className="text-center mb-12 animate-fade-in">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-3">
            🧮 GST & Income Tax Calculator
          </h1>
          <p className="text-lg text-gray-600">
            Professional tax calculator for Indian businesses | <span className="font-semibold">Vyqda.com/tools</span>
          </p>
          <div className="mt-4 flex items-center justify-center gap-2 text-sm text-gray-500">
            <span className="inline-flex items-center px-3 py-1 rounded-full bg-green-100 text-green-800 font-medium">
              ✓ Offline Support
            </span>
            <span className="inline-flex items-center px-3 py-1 rounded-full bg-blue-100 text-blue-800 font-medium">
              ✓ Real-time Calculation
            </span>
          </div>
        </header>

        {/* Tab Navigation */}
        <div className="mb-8 overflow-x-auto">
          <div className="flex gap-2 min-w-max md:min-w-0 md:justify-center pb-2">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-6 py-3 rounded-lg font-semibold transition-all duration-200 whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'bg-primary-600 text-white shadow-lg transform scale-105'
                    : 'bg-white text-gray-700 hover:bg-gray-50 shadow'
                }`}
              >
                <span className="mr-2">{tab.icon}</span>
                {tab.name}
              </button>
            ))}
          </div>
        </div>

        {/* Calculator Components */}
        <div className="animate-slide-up">
          {activeTab === 'gst' && <GSTCalculator />}
          {activeTab === 'income-tax' && <IncomeTaxCalculator />}
          {activeTab === 'tds' && <TDSCalculator />}
          {activeTab === 'advance-tax' && <AdvanceTaxCalculator />}
        </div>

        {/* Footer */}
        <footer className="mt-16 text-center text-gray-500 text-sm">
          <p className="mb-2">
            Made with ❤️ for Indian businesses | Part of Vyqda Tools Suite
          </p>
          <p className="text-xs">
            Disclaimer: This calculator provides estimates only. Please consult a CA for accurate tax filing.
          </p>
        </footer>
      </div>
    </div>
  );
}

export default App;

